import { Store } from "pullstate";
export default new Store({
  fcmToken: "",
  RNfcmToken: "",
  user: {},
  userInfo: null,
  formDetails: {},
  reportDetails: {},
  uploadModal: {
    isOpen: false,
    hasCurrentPatient: false
  },
  isEditPatientOpen: false,
  isLogoutOpen: false,
  sharingPatient: 0,
  isGetFullAccessOpen: true,
  enableViewerAPICall: true,
  enableSidebarAPICall: false,
  patient: {},
  patientDetail: {},
  isDarkMode: null,
  isExportDataOpen: false,
  isStartingDownload: false,
  isChangeRegionModalOpen: false,
  isFindingsSettingsOpen: false,
  isAutomatedConditionOpen: false,
  isCreateUserGroup: false,
  isAutomatedFindingsOpen: false,
  isMatchingPatientOpen: false,
  isFormSelectorVisible: false,
  formName: "",
  formId: "",
  isIncomingForm: false,
  emergencyPatientId: null,
  isEmergencyModalOpen: false,
  isConfirmationModalOpen: false,
  userSettings: {},
  appConfig: {},
  downloadExport: false,
  isExportReady: false,
  downloadProgress: 0,
  exportTimestamp: "",
  exportGenFailed: false,
  swiftModeEnabled: false,
  isRNTestBuild: false,
  RNSelectedEnv: "PROD",
  isRNEnvSelectorOpen: false,
  showExportUpdate: false,
  isRNAppStateChange: false,
  RNAppVersion: "",
  newPatientId: "",
  isNotificationSubscribing: false,
  showMobileStudySelector: false,
  hasUpdatedStudy: false,
  isRemoteAccessOpen: false,
  showMobileReport: false,
  isQXRModality: false,
  addPhoneModal: false,
  hasLicenseExpiredForSelectedPatient: false,
  isSettingsOpen: false,
  hasUnsavedSetting: false,
  selectedSetting: "",
  settingPageNo: 0,
  settingParams: {},
  showUnsavedWarning: false,
  isDiskSpaceWarning: false,
  patientsFileDeletionStatus: "",
  worklistSyncStatus: {},
  hasMobileSearch: false,
  worklistCloudSyncStatus: {},
  isqTrack: false,
  isAssistantOpen: false,
  isDraggableModalOpen: false,
  isDraggableModalMinimized: false,
  isDraggableModalMaximized: false,
  chatInputContent: ""
});